function createPayload(_ref) {
  var events = _ref.events,
      headers = _ref.headers;
  var payloadWithSequence; // XXX: newline is needed to separate sequence id from events

  var replayHeaders = "".concat(JSON.stringify(headers), "\n");

  if (typeof events === 'string') {
    payloadWithSequence = "".concat(replayHeaders).concat(events);
  } else {
    var enc = new TextEncoder(); // XXX: newline is needed to separate sequence id from events

    var sequence = enc.encode(replayHeaders); // Merge the two Uint8Arrays

    payloadWithSequence = new Uint8Array(sequence.length + events.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(events, sequence.length);
  }

  return payloadWithSequence;
}

export { createPayload };